var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    { attrs: { "max-show-size": "md" } },
    [
      _c(
        "app-toolbar",
        [
          _c(
            "w-toolbar-item",
            {
              attrs: { disabled: _vm.stocks.length == 0 || _vm.isSaving },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "save" } })],
            1
          ),
          _c(
            "w-toolbar-item",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-content",
                        [
                          _c("app-edit-row", {
                            attrs: { value: _vm.selectedRow },
                            on: {
                              add: function ($event) {
                                return _vm.addRow($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.stocks, function (row, i) {
            return _c(
              "w-row",
              { key: i },
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [
                    _c("app-row", {
                      attrs: { row: row },
                      on: {
                        remove: function ($event) {
                          return _vm.removeRow(row)
                        },
                        edit: function ($event) {
                          return _vm.editRow(row)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }